import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Timesheet } from '../../../../models/timesheet';
import { TimesheetService } from '../../../../services/rs/timesheet.service';
import { Tablet } from '../../../../models/tablet';
import { Page } from '../../../../models/paging/page';
import { TabletService } from '../../../../services/rs/tablet.service';

import { saveAs as importedSaveAs } from 'file-saver';
import { AuthService } from '../../../../services/auth.service';
import { FilterService } from '../../../../services/filter.service';
import { ReportableService } from '../../../../services/reportable.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.css']
})
export class TimesheetComponent implements OnInit {

  page = new Page();
  rows: any[];
  users: Tablet[];



  filter: any = {
    pdaUserId: 0,
    status: 0,
    date_Range: 0,
    //start_Date: moment().add(-1, 'months').toDate(),
    start_Date: moment(this.getMonday(new Date())).add(-7, 'days').toDate(),
    end_Date: moment(this.getMonday(new Date())).add(-1, 'days').toDate(),
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));


  getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); 
    return new Date(d.setDate(diff));
  }
  constructor(private timesheetService: TimesheetService,
    private tabletUserService: TabletService,
    private router: Router, private authService: AuthService,
    private confirmationService: ConfirmationService,
    private filterService: FilterService,
    public reportableService: ReportableService) {
    this.page.pageNumber = 0;
    this.page.size = 10;

    // Check if any filters are present
    //var filters = filterService.getFilters(authService.currentUser.value.id, this.router.url);
    //if (filters != null)
    //  this.filter = filters;

    tabletUserService.getAll().then((data) => {
      this.users = data;
    });
  }

  loadTable(page: Page) {
    //if (this.filter.pdaUserId == null || this.filter.pdaUserId == "") {
    //  this.rows = [];
    //}

    //this.filterService.saveFilters(this.authService.currentUser.value.id, this.router.url, this.filter);
    this.timesheetService.getResults(this.page, this.filter.pdaUserId, this.filter.status, this.filter.start_Date, this.filter.end_Date)
      .then((pagedData) => {
        this.page = pagedData.page;
        this.rows = pagedData.data;
      })
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }
  prevWeek(startDate,EndDate) {
    this.filter.start_Date = moment(startDate).add(-7, 'days').toDate();
    this.filter.end_Date = moment(EndDate).add(-7, 'days').toDate();
  }
  nextWeek(startDate, EndDate) {
    this.filter.start_Date = moment(startDate).add(+7, 'days').toDate();
    this.filter.end_Date = moment(EndDate).add(+7, 'days').toDate();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.loadTable(this.page);
  }

  open(id: string, engineerName: string, date: string, addDays: number) {
    //this.router.navigate(['administration/timesheets/view', id]);
    this.router.navigate(['administration/timesheets/view'], { queryParams: { id: id, engineerName: engineerName, date: date, addDays: addDays } });
  }

  ngOnInit() {
    //this.tabletUserService.getAll().then((data) => {
    //  this.users = data;

    //  this.loadTable(this.page);
    //});

    this.loadTable(this.page);
  };

  dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
  }

  getImages(timesheet_Id) {
    this.timesheetService.getImages(timesheet_Id).then((data) => {
      importedSaveAs(data, 'Images.zip');
    });
  }
  generateExcel() {
    this.timesheetService.getExcel(this.page, this.filter.pdaUserId, this.filter.start_Date, this.filter.end_Date).then((data) => {
      importedSaveAs(data, 'Report.xlsx');
    });
  }
  gotoTop() {
    console.log("GOTO TOP");
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    console.log(top);
    if (top !== null) {
      top.scrollIntoView();
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }
  approve(day) {
    //let jobDetails = 'Company: ' + job.company.name + '<br/>';
    //jobDetails += 'Location: ' + job.location.name + '<br/>';

    console.log(day);
    let timesheetDetails = 'Job No: ' + day.job_No + ',' + ' Engineer: ' + day.engineer + ',' + ' Date: ' + day.day;
    this.confirmationService.confirm({
      message: 'Are you sure that you want approve this timesheet?</br><br/>' + timesheetDetails,
      accept: () => {
        this.timesheetService.approve(day.id).then(() => {
          this.loadTable(this.page);
        });
      }
    });
  }

  amend(day) {
    this.router.navigate(['administration/timesheets/amend'], { queryParams: { id: day.id } });
  }

  downloadReport(id: string) {
    this.reportableService.getTimesheet(id).then((data) => {
      importedSaveAs(data, 'Timesheet Report.pdf');
    });
  }

  downloadSummary() {
    var start_Date = moment(this.filter.start_Date).format('YYYY-MM-DD');
    var end_Date = moment(this.filter.end_Date).format('YYYY-MM-DD');
    this.reportableService.getTimesheetsummary(start_Date, end_Date, this.filter.pdaUserId).then((data) => {
      importedSaveAs(data, 'Timesheet Report.pdf');
    });
  }
}
